// removed by extract-text-webpack-plugin
module.exports = {"react-django-template":"DuplicateNamesModal-mobile__react-django-template___-hash--base64-5-"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/DuplicateNamesModal/DuplicateNamesModal.mobile.scss
 ** module id = 912
 ** module chunks = 1
 **/